import React, { useEffect } from "react";
import numeral from "numeral";
import useDeviceType from "../../hooks/useDeviceType";
import { getUrlParams } from "../events/utils";

const NoAccount = ({
  value,
  enterprise,
  ikname,
  inkindStateAppStoreUrl,
  inkindStatePlayStoreUrl,
  inkindStateDomain,
  handleAmplitude,
  offerAmplitudePresenter,
}) => {
  const QRCode = require(
    `../../../assets/images/enterprise/${enterprise}/icons/app-qr-code.svg`,
  );
  const phoneMock = require(
    `../../../assets/images/enterprise/${enterprise}/icons/newPhoneMock.png`,
  );
  const logo = require(
    `../../../assets/images/enterprise/${enterprise}/icons/logo.png`,
  );
  const dollarIcon = require(
    `../../../assets/images/enterprise/${enterprise}/icons/dollar-icon.svg`,
  );
  const guestGroup = require("../../../assets/images/icons/guestgroup.svg");
  const { isApple, isAndroid } = useDeviceType();

  const handleClick = async () => {
    await handleAmplitude("click_open_inKind_app", {});
    setTimeout(() => {
      window.open(inkindStateDomain);
    }, 500);
  };

  useEffect(() => {
    handleAmplitude("claim_offer", {});
  }, []);

  return (
    <div className="no-account">
      <div className="welcome-bonus-container">
        <div className="welcome-bonus-top">
          <p className="superheader">LAST STEP</p>
          <div className="offer-claim-header">Download the {ikname} app!</div>
        </div>
        <div className="welcome-bonus-restrictions">
          {offerAmplitudePresenter?.on_claim_welcome_text && (
            <div
              dangerouslySetInnerHTML={{
                __html: offerAmplitudePresenter?.on_claim_welcome_text.replace(
                  "{ikname}",
                  ikname,
                ),
              }}
            />
          )}
        </div>
        <div className="divider-new"></div>
      </div>

      <div className="unlocked-panel-container">
        <div className="unlocked-panel-top">
          <div className="phone-display" onClick={handleClick}>
            <div className="iphone-container">
              <div
                className="iphone-bg"
                style={{
                  backgroundImage: `url(${phoneMock})`,
                }}
              >
                <div className="unlocked-phone-container">
                  <img className="unlocked-offer-header" src={logo} />
                  <p className="unlocked-primary-header">
                    {numeral(value).format("$0[.]00")}
                  </p>
                  {<p className="unlocked-secondary-header">Added</p>}
                </div>
              </div>
            </div>
          </div>
          <div className="unlocked-offer-claim-container code-main">
            <div className="download-links-desktop">
              <img className="qrcode" src={QRCode} onClick={handleClick} />
              <div className="download-app-btns">
                <a
                  className="download-button apple-button"
                  href={inkindStateAppStoreUrl}
                  target="_blank"
                  style={{ display: isAndroid ? "none" : "" }}
                ></a>
                <a
                  className="download-button google-button"
                  href={inkindStatePlayStoreUrl}
                  target="_blank"
                  style={{ display: isApple ? "none" : "" }}
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div className="unlocked-panel-bottom" onClick={handleClick}>
          <img src={dollarIcon} alt="dollar icon" className="dollar-icon" />
          <p>Download the {ikname} app to pay</p>
        </div>
      </div>
      <section className="guests-paid">
        {" "}
        <img src={guestGroup} alt="guest avatars" />
        {offerAmplitudePresenter?.on_claim_guests_paid_text && (
          <div
            dangerouslySetInnerHTML={{
              __html:
                offerAmplitudePresenter?.on_claim_guests_paid_text.replace(
                  "{ikname}",
                  ikname,
                ),
            }}
          />
        )}
      </section>
    </div>
  );
};

export default NoAccount;
